import React from "react";
import { Button } from "ui-kit-takeat";
import { SYSTEMS, STATUS_OPTIONS } from "./constants";
import {
  Card,
  CardThumb,
  CardBody,
  CardTitle,
  CardInfo,
  BadgesRow,
  Badge,
  CardActions,
} from "./styles";

const STATUS_COLORS = {
  active: "#28a745",
  draft: "#FFB32F",
  archived: "#6c757d",
};

function systemLabel(key) {
  const s = SYSTEMS.find((x) => x.key === key);
  return s ? s.label : key;
}

function statusLabel(value) {
  const s = STATUS_OPTIONS.find((x) => x.value === value);
  return s ? s.label : value;
}

function formatDate(value) {
  if (!value) return null;
  try {
    return new Date(value).toLocaleDateString("pt-BR");
  } catch (e) {
    return value;
  }
}

function BannerCard({ banner, onEdit, onDelete, canManage }) {
  const imageUrl = banner.images && banner.images[0] && banner.images[0].file
    ? banner.images[0].file.url
    : null;

  const route =
    banner.route_scope === "custom" ? banner.route_path : "Página principal";

  return (
    <Card>
      <CardThumb>{imageUrl && <img src={imageUrl} alt={banner.title} />}</CardThumb>
      <CardBody>
        <CardTitle>{banner.title}</CardTitle>

        <BadgesRow>
          <Badge color={STATUS_COLORS[banner.status]}>
            {statusLabel(banner.status)}
          </Badge>
          {(banner.target_systems || []).map((sys) => (
            <Badge key={sys} color="#5468ff">
              {systemLabel(sys)}
            </Badge>
          ))}
        </BadgesRow>

        <CardInfo>Local: {route}</CardInfo>
        {banner.expires_at && (
          <CardInfo>Expira em: {formatDate(banner.expires_at)}</CardInfo>
        )}
        <CardInfo>
          {(banner.images || []).length} imagem(ns) ·{" "}
          {(banner.buttons || []).length} botão(ões)
        </CardInfo>

        <CardActions>
          <Button
            title="Editar"
            buttonColor="#007bff"
            onClick={() => onEdit(banner)}
            containerStyles={{ height: 32 }}
            disabled={!canManage}
          />
          <Button
            title="Excluir"
            buttonColor="#C8131B"
            onClick={() => onDelete(banner)}
            containerStyles={{ height: 32 }}
            disabled={!canManage}
          />
        </CardActions>
      </CardBody>
    </Card>
  );
}

export default BannerCard;
